import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "environments/environment";

import { map, switchMap } from "rxjs/operators";
import { UserForm } from "app/interfaces/user-form.interface";
import { Observable } from "rxjs";

const videoRecordFunctionsHelloUrlApi =
  environment.videoRecordFunctionsHelloUrlApi;

const videoRecordFunctionsGetUsersUrlApi =
  environment.videoRecordFunctionsGetUsersUrlApi;

const videoRecordFunctionsGetRecordDaysUrlApi =
  environment.videoRecordFunctionsGetRecordDaysUrlApi;

const videoRecordFunctionsQueryFileListUrlApi =
  environment.videoRecordFunctionsQueryFileListUrlApi;

const videoRecordFunctionsDownloadVideoUrlApi =
  environment.videoRecordFunctionsDownloadVideoUrlApi;

const videoRecordFunctionsGetVersionInfoUrlApi =
  environment.videoRecordFunctionsGetVersionInfoUrlApi;

const videoRecordFunctionsGetRegisterInfoUrlApi =
  environment.videoRecordFunctionsGetRegisterInfoUrlApi;

const videoRecordFunctionsGetDownloadVideoSizeUrlApi =
  environment.videoRecordFunctionsGetDownloadVideoSizeUrlApi;

const videoRecordFunctionsGetCameraInfoUrlApi =
  environment.videoRecordFunctionsGetCameraInfoUrlApi;

const videoRecordFunctionsGetConfigValuesUrlApi =
  environment.videoRecordFunctionsGetConfigValuesUrlApi;

const videoRecordFunctionsShutdownUrlApi =
  environment.videoRecordFunctionsShutdownUrlApi;

const videoRecordFunctionsLogoutUrlApi =
  environment.videoRecordFunctionsLogoutUrlApi;

@Injectable()
export class VideoRecordService {
  public user: UserForm;

  constructor(private http: HttpClient) {}

  hello(ip, port) {
    const body = {
      ip: ip,
      port: port,
    };
    return this.http
      .request("POST", `${videoRecordFunctionsHelloUrlApi}`, { body })
      .pipe(map((resp: any) => resp));
  }

  getRegisterInfo(id: number, ip, port) {
    const body = {
      ip: ip,
      port: port,
    };
    return this.http
      .request("POST", `${videoRecordFunctionsGetRegisterInfoUrlApi}`, {
        body,
      })
      .pipe(map((resp: any) => resp));
  }
  getVersionInfo(id: number, ip, port) {
    const body = {
      ip: ip,
      port: port,
    };
    return this.http
      .request("POST", `${videoRecordFunctionsGetVersionInfoUrlApi}`, { body })
      .pipe(map((resp: any) => resp));
  }

  getCameraInfo(id: number, ip, port) {
    const body = {
      ip: ip,
      port: port,
    };
    return this.http
      .request("POST", `${videoRecordFunctionsGetCameraInfoUrlApi}`, { body })
      .pipe(map((resp: any) => resp));
  }

  getUsers(id: number, ip, port) {
    const body = {
      ip: ip,
      port: port,
    };
    return this.http
      .request("POST", `${videoRecordFunctionsGetUsersUrlApi}`, { body })
      .pipe(map((resp: any) => resp));
  }

  getRecordDays(ip, port) {
    const body = {
      ip: ip,
      port: port,
    };
    return this.http
      .request("POST", `${videoRecordFunctionsGetRecordDaysUrlApi}`, { body })
      .pipe(map((resp: any) => resp));
  }

  queryFileList(ip, port) {
    const body = {
      ip: ip,
      port: port,
    };
    return this.http
      .request("POST", `${videoRecordFunctionsQueryFileListUrlApi}`, { body })
      .pipe(map((resp: any) => resp));
  }

  getConfigValues(ip, port) {
    const body = {
      ip: ip,
      port: port,
    };
    return this.http
      .request("POST", `${videoRecordFunctionsGetConfigValuesUrlApi}`, { body })
      .pipe(map((resp: any) => resp));
  }

  getDownloadVideoSize(ip, port, urlVideo) {
    const body = {
      ip: ip,
      port: port,
      urlVideo: urlVideo,
    };
    return this.http
      .request("POST", `${videoRecordFunctionsGetDownloadVideoSizeUrlApi}`, {
        body,
      })
      .pipe(map((resp: any) => resp));
  }

  downloadVideo(ip, port, urlVideo) {
    const body = {
      ip: ip,
      port: port,
      urlVideo: urlVideo,
    };
    return this.http
      .request("POST", `${videoRecordFunctionsDownloadVideoUrlApi}`, {
        body,
        responseType: "blob",
      })
      .pipe(switchMap((response) => this.readFile(response)));
  }

  private readFile(blob: Blob): Observable<string> {
    return Observable.create((obs) => {
      const reader = new FileReader();
      reader.onerror = (err) => obs.error(err);
      reader.onabort = (err) => obs.error(err);
      reader.onload = () => obs.next(reader.result);
      reader.onloadend = () => obs.complete();
      return reader.readAsDataURL(blob);
    });
  }

  shutdown(id: number, ip, port) {
    const body = {
      ip: ip,
      port: port,
    };
    return this.http
      .request("POST", `${videoRecordFunctionsShutdownUrlApi}`, { body })
      .pipe(map((resp: any) => resp));
  }

  logout(id: number, ip, port) {
    const body = {
      ip: ip,
      port: port,
    };
    return this.http
      .request("POST", `${videoRecordFunctionsLogoutUrlApi}`, { body })
      .pipe(map((resp: any) => resp));
  }
}
